import {
  ClearButton,
  DropdownContent,
  DropdownTrigger,
  ElementProps,
  Icon,
  IconName,
  Row,
  Dropdown as SharedDropdown,
  DropdownProps as SharedDropdownProps,
} from '@vuddy/components';
import { HTMLAttributes, ReactNode } from 'react';
import * as styles from './dropdown.css';

export interface DropdownProps<T = {}> extends Omit<
  SharedDropdownProps,
  'children' | 'options'
> {
  children: ReactNode;
  options: ({
    id: string | number;
    label: string;
    iconName?: IconName;
    color?: ElementProps['color'];
  } & T)[];
  onMenuClick: (id: string | number) => void;
  triggerClassName?: string;
  triggerProps?: Omit<HTMLAttributes<HTMLDivElement>, 'children'>;
  contentClassName?: string;
  renderOptionClassName?: string;
  renderOption?: (option: any) => ReactNode;
  footer?: ReactNode | ((setOpen: (open: boolean) => void) => ReactNode);
  closeOnOptionClick?: boolean;
  optionsWrapperClassName?: string;
  hasParentWidth?: boolean;
}

export const Dropdown = ({
  children,
  options,
  onMenuClick,
  triggerClassName,
  triggerProps,
  contentClassName,
  renderOptionClassName,
  renderOption,
  footer,
  closeOnOptionClick = true,
  optionsWrapperClassName,
  hasParentWidth = false,
  ...props
}: DropdownProps) => {
  return (
    <SharedDropdown {...props}>
      <DropdownTrigger {...triggerProps} className={triggerClassName}>
        {children}
      </DropdownTrigger>
      <DropdownContent
        hasParentWidth={hasParentWidth}
        className={contentClassName ?? styles.content}
        options={options}
        onClick={onMenuClick}
        footer={footer}
        closeOnOptionClick={closeOnOptionClick}
        optionsWrapperClassName={optionsWrapperClassName}
        renderOption={
          renderOption
            ? renderOption
            : option => (
                <ClearButton fullWidth>
                  <Row
                    className={renderOptionClassName ?? styles.renderOption}
                    color={option.color ?? 'primary'}>
                    {option.iconName && (
                      <Icon name={option.iconName} size="16px" />
                    )}
                    {option.label}
                  </Row>
                </ClearButton>
              )
        }
      />
    </SharedDropdown>
  );
};
